import React from 'react'
import ReactDOM from 'react-dom'
import {Faqs} from '../Faqs'

/**
 * Initialisation callback
 */
const woodgreenFaqsInit = () => {
  console.log('Hello from the Woodgreen Payments FAQs module')

  const appRootElementID = 'footer-faqs'
  const appRootElement   = document.getElementById(appRootElementID)

  console.log('wgFaqs', wgFaqs)

  if (appRootElement && wgFaqs) {
    ReactDOM.render(
      <Faqs faqs={wgFaqs} />,
      appRootElement
    )
  }
}

if (
  document.readyState === "complete" ||
  (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
  woodgreenFaqsInit()
} else {
  document.addEventListener("DOMContentLoaded", woodgreenFaqsInit);
}
